<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-icon v-on="on">
          mdi-information-outline
        </v-icon>
      </template>
      <span>
        <div class="d-flex">
          <div class="mr-2">
            <div class="mb-2 font-weight-bold">
              Symboles lignes du Journal :
            </div>
            <div v-for="item in logbooks" :key="item.alert" class="mb-1">
              <v-icon :color="item.color" class="mr-1">
                {{ item.icon }}
              </v-icon>
              {{ item.alert }}
            </div>
          </div>
          <div>
            <div class="mb-2 font-weight-bold">
              Divers :
            </div>
            <div v-for="item in divers" :key="item.alert" class="mb-1">
              <v-icon :color="item.color" class="mr-1">
                {{ item.icon }}
              </v-icon>
              {{ item.alert }}
            </div>
          </div>
        </div>
      </span>
    </v-tooltip>
  </div>
</template>
<script>
import { iconLogbookArray, diversIconArray } from './LogbookIcon';

export default {
  name: 'GraphsIconCaption',
  data: () => ({
    logbooks: iconLogbookArray,
    divers: diversIconArray,
  }),
};
</script>
